var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", [_vm.type === 3 ? _c("span", {
    staticClass: "searching-animation-3"
  }) : _c("span", [_c("svg-icon", {
    class: [_vm.animation ? _vm.loadingClass : ""],
    attrs: {
      name: _vm.iconName,
      size: _vm.size
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };